/* eslint-disable */
import Swiper, { Navigation, Pagination, Autopplay, Autoplay } from "swiper";
import AOS from "aos";

export default {
  init() {
    // JavaScript to be fired on all pages

    AOS.init();

    // ajax function that handles filter on click of button with class filter--trigger
    if ($(".loadmore--trigger").length > 0) {
      $(".loadmore--trigger").on("click", function (e) {
        const trigger = $(this);

        // get data attribute posttype from button
        const posttype = trigger.data("posttype");
        const totalAmount = trigger.data("total-amount");
        const url = trigger.data("action");

        // get amount of elements with class shown--project
        const currentAmount = $(`.shown--${posttype}`).length;
        const addition = 9;
        console.log(posttype, addition, currentAmount);

        $.ajax({
          url: url,
          type: "POST",
          data: {
            action: "loadmore",
            posttype,
            addition,
            currentAmount,
          },
          error: function (response) {
            console.log("err", response);
          },
          // loading
          beforeSend: function () {
            $(`#response--${posttype}`).css("opacity", 0.5);
          },
          success: function (response) {
            // replace content of element with class filter--results with response
            $(`#response--${posttype}`).css("opacity", 1);
            if (totalAmount <= currentAmount + addition) {
              trigger.hide();
            }
            $(`#response--${posttype}`).html(response);
          },
        });
      });
    }

    //mobile menu

    document
      .querySelector("#mobile-menu--trigger")
      .addEventListener("click", openMobileMenu);
    document
      .querySelector("#mobile-menu--exit")
      .addEventListener("click", closeMobileMenu);

    function openMobileMenu() {
      document
        .querySelector(".mobile-menu")
        .classList.add("mobile-menu--active");
      window.isMenuOpened = true;
    }

    function closeMobileMenu() {
      document
        .querySelector(".mobile-menu")
        .classList.remove("mobile-menu--active");
      window.isMenuOpened = false;
    }

    $("#scrollTop").on("click", () => {
      window.scroll(0, 0);
    });

    //swiper

    if ($(".image-slider__slider").length) {
      Swiper.use([Navigation, Pagination]);

      new Swiper(".image-slider__slider", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    if ($("#review-swiper").length) {
      Swiper.use([Navigation, Pagination, Autoplay]);

      new Swiper("#review-swiper", {
        autoHeight: false,
        slidesPerView: 1,
        spaceBetween: 50,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    // Change & letter
    const textToChange = document.querySelector(".hero-content h1").textContent;
    const textChanged = textToChange.replace(
      "&",
      "<br><span class='babet-no-like-font'>&</span>"
    );
    document.querySelector(".hero-content h1").innerHTML = textChanged;

    $(".nav-item").on("click", (e) => {
      let id = e.currentTarget.id;
      let target = "target-" + id;

      $(".nav-item").removeClass("active");
      $("#" + id).addClass("active");

      $(".inner-content").hide();
      $("#" + target).fadeIn();
    });

    let checkWindow = window.matchMedia("(max-width: 1024px)");
    let checkMinWindow = window.matchMedia("(min-width: 1025px)");

    if (checkMinWindow.matches) {
      $(".nav-item-faq").on("click", (e) => {
        let id = e.currentTarget.id;
        let target = id + "-target";

        $(".nav-item-faq").removeClass("active");
        $("#" + id).addClass("active");

        $(".inner-content-faq").hide();
        $("#" + target).fadeIn();
      });
    }

    if (checkWindow.matches) {
      const faqAnswers = document.querySelectorAll(".inner-content-faq");

      faqAnswers.forEach((el) => {
        let text = el.querySelector(".text").innerHTML;
        let id = el.dataset.id;

        $("#faq-" + id + "-mobile").html(text);
      });

      $(".nav-item-faq").on("click", (e) => {
        let id = e.currentTarget.id;
        let target = id + "-mobile";

        $(".nav-item-faq").removeClass("active");
        $("#" + id).addClass("active");

        $(".mobile-answer").hide();
        $("#" + target).fadeIn();
      });
    }

    // Scroll ID(anchor) to animation
    $('a[href^="#"]').on("click", function (event) {
      var target = $(this.getAttribute("href"));
      var textTar = $(this).attr("href");
      if (target.length) {
        event.preventDefault();
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: target.offset().top - 100,
            },
            1000
          );
      } else {
        location.href = "/" + textTar;
      }
    });

    if ($(".text-banner").length) {
      $("#text-banner__exit").on("click", function () {
        $(".text-banner").hide();
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js